import React from "react";
import { Col, FormGroup, Row } from "reactstrap";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "../../../../../constants/StringConstants";

const CommentsFields = ({ priorityOptions }) => {
  return (
    <>
      <Row>
        <Col sm="3">
          <Row>
            <Col sm="8">
              <SimpleDatePickerField
                label={S.APP_COMMENTS_FIELD_FOLLOW_UP_DATE_LABEL}
                name="followUpDate"
                isFormMode
                showClear
              />
            </Col>
          </Row>
        </Col>
        <Col sm="3">
          <Row>
            <Col sm="8"></Col>
            <Col sm="8">
              <FormGroup>
                <TypeaheadField
                  name="commentPriorityID"
                  label={S.APP_COMMENTS_FIELD_PRIORITY_LABEL}
                  options={priorityOptions}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <TextField name="description" label={S.APP_COMMENTS_FIELD_DESCRIPTION_LABEL} />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default CommentsFields;
